var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-footer',{staticClass:"color-footer"},[_c('div',{staticClass:"row justify-center items-center col-12 bg-footer text-center q-px-sm q-pb-sm q-py-md"},[_vm._v(" Copyright © "+_vm._s(_vm.fecha)+". "+_vm._s(_vm.$t("messages.copyright"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }